module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvY29zdGFsLTQtMi4wM2M0YTMwMi5qcGciOw=="